import { useQuery } from "@tanstack/react-query";
import { folderSearch } from "query-api/search";

interface SearchParams {
  keyword: string;
}

export const useFolderSearch = (props: SearchParams) => {
  const { keyword } = props;

  const { data, isError, isLoading } = useQuery({
    queryKey: ["folderSearch", keyword],
    queryFn: async () => {
      const { data } = await folderSearch({
        keyword,
      });

      return data;
    },
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
